import { Card as AntdCard, CardProps as AntdCardProps } from 'antd'

interface CardProps extends AntdCardProps {
  label?: string
}

export const Card = (props: CardProps) => {
  return <AntdCard {...props} />
}

Card.defaultProps = {
  style: {
    width: '100%',
    marginBottom: 20
  }
}
